// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1id3V","icon":"styles_icon__yTTYj","primary":"styles_primary__o6qOS","dark":"styles_dark__2-Pcb"};